export const deepReads = [
  {
    id: "dp-01",
    category: "事件复盘",
    title: "从爆红到被围攻：一个品牌的 30 天舆情曲线长什么样",
    summary:
      "我们把 30 天里的每一条公开表态按时间排开，发现真正的转折点，出现在一次看似无关的回应之后。",
    author: "周照",
    readTime: "9 分钟",
    date: "09-12",
    comments: 214,
    featured: true,
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20abstract%20of%20an%20empty%20boardroom%20table%20lit%20by%20warm%20amber%20window%20light%20with%20long%20shadows%2C%20charcoal%20and%20cream%20tones%2C%20simple%20minimal%20background%2C%20artistic%20conceptual%20editorial%20photography%2C%20no%20text%2C%20high%20detail&width=800&height=600&seq=hlkd-read-01&orientation=landscape",
  },
  {
    id: "dp-02",
    category: "细节考据",
    title: "那封被反复转发的内部信，其实少了一整段",
    summary:
      "对比流传最广的版本与原始截图，被删掉的一段恰好解释了后续所有争吵。",
    author: "林禾",
    readTime: "6 分钟",
    date: "09-11",
    comments: 168,
    featured: false,
    image:
      "https://readdy.ai/api/search-image?query=abstract%20stack%20of%20vintage%20envelopes%20and%20sealed%20letters%20on%20a%20warm%20cream%20desk%20under%20soft%20amber%20light%2C%20charcoal%20shadows%2C%20simple%20uncluttered%20background%2C%20editorial%20still%20life%20photography%2C%20no%20text&width=800&height=600&seq=hlkd-read-02&orientation=landscape",
  },
  {
    id: "dp-03",
    category: "观点拆解",
    title: "同一个事实，为什么两边都觉得自己在理",
    summary:
      "争议的核心不是谁撒谎，而是双方在无意中采用了两套完全不同的判断标准。",
    author: "沈奕",
    readTime: "7 分钟",
    date: "09-10",
    comments: 302,
    featured: false,
    image:
      "https://readdy.ai/api/search-image?query=abstract%20reflection%20of%20a%20silhouette%20in%20a%20cracked%20antique%20mirror%2C%20warm%20amber%20and%20charcoal%20palette%2C%20soft%20cinematic%20haze%2C%20simple%20dark%20background%2C%20artistic%20editorial%20conceptual%20photography%2C%20no%20text&width=800&height=600&seq=hlkd-read-03&orientation=landscape",
  },
  {
    id: "dp-04",
    category: "行业脉络",
    title: "同期被下架的三款产品，暴露了一条正在收紧的规则",
    summary:
      "把时间、品类和处置理由放在一起看，这轮调整并非针对某一家，而是一条更长的线。",
    author: "看点研究室",
    readTime: "8 分钟",
    date: "09-09",
    comments: 137,
    featured: false,
    image:
      "https://readdy.ai/api/search-image?query=abstract%20scene%20of%20fog%20rolling%20over%20a%20quiet%20city%20rooftop%20at%20dawn%20in%20warm%20amber%20and%20charcoal%20tones%2C%20soft%20cinematic%20light%2C%20simple%20minimal%20background%2C%20artistic%20editorial%20photography%2C%20no%20text&width=800&height=600&seq=hlkd-read-04&orientation=landscape",
  },
];